export default {
  path: '/provider-imports/:id',
  name: 'provider-import',
  component: () => import(/* webpackChunkName: "imported-provider" */ './ImportedProvider'),
  props: true,
  meta: { requiresAuth: true }
}
